export default "__VITE_ASSET__BlpqIhdv__"